import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'owner'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    owner: new AclRule('owner').generate(),
    admin: new AclRule('admin').or('owner').generate(),
    agent: new AclRule('agent').or('sales').or('owner').or('admin').generate(),
    sales: new AclRule('sales').or('agent').or('owner').or('admin').generate(),
    guest: new AclRule('admin').or('owner').or('sales').or('agent').generate(),
  }
});
